import React, { useState } from 'react';
import { useCloudAuth } from '../../context/CloudAuthContext';

const features = [
  'AI-powered voice agents that handle calls 24/7',
  'Natural conversations with real-time transcription',
  'Customizable voice and language settings',
  'Detailed call analytics and reporting',
  'Seamless integration with Twilio and ElevenLabs',
];

export default function ActivateService({ onActivate }) {
  const { fetchApi } = useCloudAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleActivate = async () => {
    setLoading(true);
    setError(null);
    try {
      await fetchApi('/api/cloud/auth/services/voice/activate', { method: 'POST', body: JSON.stringify({}) });
      onActivate();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-8">
      <div className="max-w-lg w-full text-center">
        {/* Icon */}
        <div className="w-20 h-20 mx-auto mb-6 bg-purple-900/50 rounded-full flex items-center justify-center">
          <svg className="w-10 h-10 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-white mb-3">Voice Agent</h1>
        <p className="text-gray-400 mb-8">Deploy AI-powered voice agents to handle inbound and outbound calls</p>

        {/* Features */}
        <div className="bg-[#111113] rounded-lg border border-gray-800 p-6 mb-8 text-left">
          <h3 className="text-sm font-medium text-gray-400 uppercase mb-4">What you get</h3>
          <ul className="space-y-3">
            {features.map((feature, idx) => (
              <li key={idx} className="flex items-start gap-3">
                <svg className="w-5 h-5 text-green-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-gray-300">{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        {error && (
          <div className="mb-4 p-4 bg-red-900/50 border border-red-500 rounded-lg text-red-300">
            {error}
          </div>
        )}

        <button
          onClick={handleActivate}
          disabled={loading}
          className="w-full py-3 px-6 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 text-white rounded-lg font-medium text-lg transition-colors"
          data-testid="activate-voice-btn"
        >
          {loading ? 'Activating...' : 'Activate Voice Agent'}
        </button>

        <p className="mt-4 text-sm text-gray-500">
          No credit card required • Cancel anytime
        </p>
      </div>
    </div>
  );
}
